import { render, staticRenderFns } from "./AcademicPlan.vue?vue&type=template&id=e95b7ac0&"
import script from "./AcademicPlan.vue?vue&type=script&lang=js&"
export * from "./AcademicPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports